//#region src/vitrine_cover_pathway_block_type.ts
let VitrinePathwayBlockType = /* @__PURE__ */ function(VitrinePathwayBlockType) {
	VitrinePathwayBlockType["WayFinder"] = "wayfinder";
	VitrinePathwayBlockType["Quiz"] = "quiz";
	VitrinePathwayBlockType["Loyalty"] = "loyalty";
	VitrinePathwayBlockType["Experiences"] = "experiences";
	return VitrinePathwayBlockType;
}({});
//#endregion
export { VitrinePathwayBlockType };

//# sourceMappingURL=vitrine_cover_pathway_block_type.js.map